import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ConfigurationClient, ConfigurationEntry, MapClientConfiguration } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    constructor(private readonly client: ConfigurationClient) {}

    async getMapConfiguration(): Promise<MapClientConfiguration> {
        return await lastValueFrom(this.client.configurationGetMapConfiguration());
    }

    async getConfigurationEntries(): Promise<ConfigurationEntry[]> {
        return await lastValueFrom(this.client.configurationGetConfigurationEntries());
    }
}
